import { createEffect, createSignal, Index, type JSX, on } from 'solid-js';
import type { HudItem } from '../lib/fleet-live';

// A Fleet Live panel's HUD (#6778, prototype hudHTML, `:4086`): "In flight", "Queued",
// "Busy", "Merged today", "Median cycle", each only when #6777 sent its field (the model,
// `fleet-live.ts`, decides; "CI pass" has no source and does not exist). A number that
// changes highlights for 500 ms: the class flips so the CSS animation restarts, and the
// animation itself sits inside `reduce-motion`, so a still frame highlights nothing.

export function FleetLiveHud(props: { readonly items: readonly HudItem[] }): JSX.Element {
  return (
    <ul class="fleet-live__stats">
      <Index each={props.items}>
        {(item) => {
          const [flip, setFlip] = createSignal<boolean | null>(null);
          createEffect(
            on(
              () => item().value,
              () => setFlip((f) => (f === null ? false : !f)),
              { defer: true },
            ),
          );
          return (
            <li title={item().title}>
              {item().label}
              <b
                class="fleet-live__stat-value"
                classList={{
                  'fleet-live__stat-value--tick-a': flip() === true,
                  'fleet-live__stat-value--tick-b': flip() === false,
                }}
              >
                {item().value}
              </b>
            </li>
          );
        }}
      </Index>
    </ul>
  );
}
